﻿/* -------------------------------------------------------------
■「販売店名」の設定
例）var HANBAITEN_NAME = "販売店名";
------------------------------------------------------------- */
var HANBAITEN_NAME = "有限会社　赤川農機";

/* -------------------------------------------------------------
■「戻るボタン遷移先」の設定
例）var BACK_URL = "販売店ページへ戻る遷移先URL";
------------------------------------------------------------- */
var BACK_URL = "https://nouki-ichiba.net/pages/loan" + window.location.search;

/* -------------------------------------------------------------
■「月々の返済金最少額」の設定
例）var MIN_PAY_MONTH = new Number( 月々の返済金最少額 )
------------------------------------------------------------- */
var MIN_PAY_MONTH = new Number(3000) ;

/* -------------------------------------------------------------
■「月々の返済金最少額アラート」を表示するか否かの設定
例）表示する場合
	MIN_PAY_MONTH_ALERT = true ;
	表示しない場合
	MIN_PAY_MONTH_ALERT = false ;
------------------------------------------------------------- */
var MIN_PAY_MONTH_ALERT = false ;

/* -------------------------------------------------------------
■「実質年率」の設定
例）LoanSimulation.NENRITSU = new Number( 実質年率 ) ;
------------------------------------------------------------- */
LoanSimulation.NENRITSU = new Number(5.9) ;

/* -------------------------------------------------------------
■「分割回数」の設定
例）LoanSimulation.MAX_OF_PAY_TIMES = new Number( 分割回数 ) ;
------------------------------------------------------------- */
LoanSimulation.MAX_OF_PAY_TIMES = new Number(60) ;

/* -------------------------------------------------------------
■「実質年率」を表示するか否かの設定
例）表示する場合
	LoanSimulation.RATE_VISIBILITY = true ;
	表示しない場合
	LoanSimulation.RATE_VISIBILITY = false ;
------------------------------------------------------------- */
LoanSimulation.RATE_VISIBILITY = true ; 

/* -------------------------------------------------------------
■「支払回数」と「分割払手数料」の設定
例）ENTRY[ ENTRY.length ] = new LoanSimulation( 支払回数, 手数料の額 ) ;
------------------------------------------------------------- */
var ENTRY = new Array( ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 3, 0.98 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 6, 1.73 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 10, 2.72 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 12, 3.22 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 15, 3.98 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 18, 4.74 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 20, 5.24 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 24, 6.26 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 30, 7.80 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 36, 9.36 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 42, 10.92 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 48, 12.51 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 54, 14.11 ) ;
ENTRY[ ENTRY.length ] = new LoanSimulation( 60, 15.72 ) ;
